<template>
  <div>
    <div>
    <div style="margin-right: 10px">
      活動開始日期：<br />
      <b-form-datepicker
        v-model="localQuery.sActiveTime"
        :date-format="flatpickrConfig.dateFormat"
        :locale="flatpickrConfig.locale" 
        size="sm"
      ></b-form-datepicker>
    </div>

    <div>
      活動結束日期：<br />
      <b-form-datepicker
        v-model="localQuery.eActiveTime"
        :date-format="flatpickrConfig.dateFormat"
        :locale="flatpickrConfig.locale"
        size="sm"
      ></b-form-datepicker>
    </div>
    </div>

    <div>
      參與招生宣導場次報表:<br />
      <select v-model="localQuery.options1Value">
        <option v-for="item in options1" :key="item.value" :value="item.value">
          {{ item.text }}
        </option>
      </select>
    </div>

    <button
      @click="onSearch"
      class="btn btn-outline-info"
      type="button"
      style="font-size: 14px"
    >
      查詢
    </button>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
export default {
  components: { flatPickr },
  props: ["queryInfo", "options1", "flatpickrConfig"],
  data() {
    return {
      localQuery: JSON.parse(JSON.stringify(this.queryInfo)),
    };
  },
  watch: {
    queryInfo: {
      handler(n) {
        this.localQuery = JSON.parse(JSON.stringify(n));
      },
      deep: true,
    },
  },
  methods: {
    deepClone(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    onSearch() {
      this.$emit("search", this.localQuery);
    },
  },
};
</script>
